import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import signInImage from '../assets/ninja.png';

const SignIn = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    console.log('sign in button clicked')
    e.preventDefault(); // Prevent form submission from reloading the page
    const response = await fetch('https://api.ninjabakers.com/api/auth/signin', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    if (response.ok) {
      navigate('/order-entry');
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 p-4">
      <div className="flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden w-full max-w-4xl">
        <div className="w-full md:w-1/2 h-64 md:h-auto bg-cover bg-center" style={{ backgroundImage: `url(${signInImage})` }}></div>
        <div className="w-full md:w-1/2 p-8 flex flex-col justify-center">
          <h2 className="text-2xl font-bold text-gray-700 text-center">Sign In</h2>
          <form className="mt-4" onSubmit={handleSignIn}>
            <div className="mb-4">
              <input type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)} // Bind value to state
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="mb-4">
              <input type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Bind value to state
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
                required />
            </div>
            <button
              type="submit" // Ensures the form triggers on submit
              className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700">
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;